<div class="tabla-container">
  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="loading-overlay">
    <div class="spinner"></div>
  </div>

  <!-- Buscador -->
  <div class="search-container" [class.hidden-on-loading]="isLoading">
    <svg
      class="search-icon"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <path d="m21 21-4.35-4.35"></path>
    </svg>
    <input
      type="text"
      class="search-input"
      placeholder="Search by Project Name or Technology"
      [(ngModel)]="searchTerm"
      (input)="onSearch()"
    />
  </div>

  <!-- Serverless filter chips -->
  <div class="filter-chips-row" [class.hidden-on-loading]="isLoading">
    <span class="filter-label">Filter:</span>
    <button
      class="filter-chip"
      [class.active]="serverlessFilter === 'all'"
      (click)="setServerlessFilter('all')"
    >
      All
    </button>
    <button
      class="filter-chip"
      [class.active]="serverlessFilter === 'serverless'"
      (click)="setServerlessFilter('serverless')"
    >
      <svg
        width="11"
        height="11"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
      </svg>
      Serverless
    </button>
    <button
      class="filter-chip"
      [class.active]="serverlessFilter === 'non-serverless'"
      (click)="setServerlessFilter('non-serverless')"
    >
      <svg
        width="11"
        height="11"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
        <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
        <line x1="6" y1="6" x2="6.01" y2="6"></line>
        <line x1="6" y1="18" x2="6.01" y2="18"></line>
      </svg>
      EC2
    </button>
  </div>

  <!-- Search result count -->
  <div class="search-results-count" [class.hidden-on-loading]="isLoading">
    <ng-container
      *ngIf="searchTerm || serverlessFilter !== 'all'; else totalCount"
    >
      Showing <strong>{{ getProjectCount() }}</strong> of
      <strong>{{ getTotalProjectCount() }}</strong> projects
    </ng-container>
    <ng-template #totalCount>
      <strong>{{ getTotalProjectCount() }}</strong> projects
    </ng-template>
  </div>

  <table class="tech-stack-table" [class.hidden-on-loading]="isLoading">
    <thead>
      <tr>
        <th>Project Name</th>
        <th>Technology</th>
        <th>Current Version</th>
        <th>End Of Life</th>
        <th>Status</th>
        <th>Recommended Version</th>
        <th>Status +1 Year</th>
        <th *ngIf="false">Prod Certificates</th>
        <th *ngIf="false">Prod Certificate Date</th>
        <th>Comments</th>
      </tr>
    </thead>
    <tbody>
      <ng-container>
        <!-- Mensaje cuando no hay resultados -->
        <tr
          *ngIf="
            filteredRepositories.length === 0 &&
            (searchTerm || serverlessFilter !== 'all')
          "
          class="no-results"
        >
          <td colspan="10" class="no-results-message">
            No projects found
            <ng-container *ngIf="searchTerm">
              matching "{{ searchTerm }}"</ng-container
            >
            <ng-container *ngIf="serverlessFilter !== 'all'">
              with <strong>{{ serverlessFilter }}</strong> filter</ng-container
            >
          </td>
        </tr>

        <!-- Filas de datos -->
        <ng-container
          *ngFor="let row of filteredRepositories; let rowIndex = index"
        >
          <!-- Calculamos el número total de tecnologías para rowspan -->
          <ng-container *ngIf="getTotalTechnologies(row) as totalTechs">
            <ng-container
              *ngFor="
                let tech of getAllTechnologies(row);
                let techIndex = index
              "
            >
              <tr
                (mouseenter)="onRowHover(rowIndex, techIndex, true)"
                (mouseleave)="onRowHover(rowIndex, techIndex, false)"
                [class.project-first-row]="techIndex === 0"
                [class.project-last-row]="techIndex === totalTechs - 1"
              >
                <!-- Project Name - solo en la primera fila -->
                <td
                  *ngIf="techIndex === 0"
                  class="project-name"
                  [attr.rowspan]="totalTechs"
                  [class.cell-hover]="isProjectColumnHovered(rowIndex)"
                >
                  <button
                    class="project-link"
                    (click)="navigateToProject(row.project)"
                    title="View project details"
                  >
                    {{ row.project | titleFormat }}
                  </button>
                  <div class="project-type">
                    <div class="icon-with-tooltip">
                      <img
                        src="../../../../../../assets/icons/{{ row.type }}.svg"
                        alt="{{ row.type }}"
                        class="project-type-icon"
                      />
                      <span class="tooltip-text">{{
                        row.type | titleFormat
                      }}</span>
                    </div>
                  </div>
                </td>

                <!-- Technology -->
                <td class="technology-cell">
                  {{ tech.tech | titleFormat }}
                </td>

                <!-- Current Version -->
                <td class="version-cell">
                  {{ tech.cleaned_version }}
                </td>

                <!-- End Of Life -->
                <td class="eol-cell" [class]="getEolUrgencyClass(tech.eol)">
                  <span class="eol-date">{{
                    formatEolDate(tech.eol)
                      ? (formatEolDate(tech.eol)! | dateFormat)
                      : "No date"
                  }}</span>
                </td>

                <!-- Status -->
                <td class="status-cell">
                  <div class="icon-with-tooltip">
                    <div
                      class="status-indicator"
                      [ngClass]="calculateTechStatus(tech, tech.tech)"
                    >
                      <span class="status-dot"></span>
                    </div>
                    <span
                      class="tooltip-text"
                      [ngClass]="{
                        'tooltip-good':
                          calculateTechStatus(tech, tech.tech) ===
                          'status-green',
                        'tooltip-danger':
                          calculateTechStatus(tech, tech.tech) === 'status-red',
                        'tooltip-caution':
                          calculateTechStatus(tech, tech.tech) ===
                          'status-orange',
                        'tooltip-gray':
                          calculateTechStatus(tech, tech.tech) ===
                          'status-gray',
                      }"
                    >
                      {{
                        calculateTechStatus(tech, tech.tech) === "status-green"
                          ? "Active Support"
                          : calculateTechStatus(tech, tech.tech) ===
                              "status-red"
                            ? "No Support"
                            : calculateTechStatus(tech, tech.tech) ===
                                "status-gray"
                              ? "No info"
                              : "Security Support"
                      }}
                    </span>
                  </div>
                </td>

                <!-- Recommended Version -->
                <td class="recommended-cell">
                  <ng-container
                    *ngIf="
                      isUpToDate(
                        getRecommendedVersion(tech.tech, tech.cleaned_version)
                      );
                      else showVersion
                    "
                  >
                    <span class="recommended-up-to-date">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      {{ tech.cleaned_version }}
                    </span>
                  </ng-container>
                  <ng-template #showVersion>
                    <span class="version-with-hint">
                      {{
                        getRecommendedVersion(tech.tech, tech.cleaned_version)
                      }}
                      <button
                        *ngIf="
                          canTriggerUpgrade(tech.tech) &&
                          getNextVersion(
                            tech.tech,
                            tech.cleaned_version
                          ) as nextVer
                        "
                        class="upgrade-pill"
                        (click)="
                          openUpgradeConfirm(
                            getUpgradeProjectName(row, tech),
                            tech.tech,
                            tech.cleaned_version,
                            nextVer
                          )
                        "
                        title="Trigger upgrade to v{{ nextVer }}"
                      >
                        <span class="upgrade-arrow" aria-hidden="true">↑</span>
                        <img
                          class="copilot-icon"
                          src="assets/icons/copilot.svg"
                          alt=""
                          aria-hidden="true"
                        />
                        <span class="sr-only">Upgrade with Copilot</span>
                      </button>
                    </span>
                  </ng-template>
                </td>

                <!-- Status +1 Year -->
                <td class="status-year-cell">
                  <div class="icon-with-tooltip">
                    <div
                      class="status-indicator"
                      [ngClass]="calculateTechStatus(tech, tech.tech, 1)"
                    >
                      <span class="status-dot"></span>
                    </div>
                    <span
                      class="tooltip-text"
                      [ngClass]="{
                        'tooltip-good':
                          calculateTechStatus(tech, tech.tech, 1) ===
                          'status-green',
                        'tooltip-danger':
                          calculateTechStatus(tech, tech.tech, 1) ===
                          'status-red',
                        'tooltip-caution':
                          calculateTechStatus(tech, tech.tech, 1) ===
                          'status-orange',
                        'tooltip-gray':
                          calculateTechStatus(tech, tech.tech, 1) ===
                          'status-gray',
                      }"
                    >
                      {{
                        calculateTechStatus(tech, tech.tech, 1) ===
                        "status-green"
                          ? "Active Security"
                          : calculateTechStatus(tech, tech.tech, 1) ===
                              "status-red"
                            ? "No Support"
                            : calculateTechStatus(tech, tech.tech, 1) ===
                                "status-gray"
                              ? "No info"
                              : "Security Support"
                      }}
                    </span>
                  </div>
                </td>

                <!-- Prod Certificates - solo en la primera fila -->
                <td
                  *ngIf="false"
                  class="prod-certificates"
                  [attr.rowspan]="totalTechs"
                  [class.cell-hover]="isProjectColumnHovered(rowIndex)"
                >
                  Azure
                </td>

                <!-- Prod Certificate Date - solo en la primera fila -->
                <td
                  *ngIf="false"
                  class="prod-certificate-date"
                  [attr.rowspan]="totalTechs"
                  [class.cell-hover]="isProjectColumnHovered(rowIndex)"
                >
                  16/Nov/2120
                </td>

                <!-- Comments - solo en la primera fila -->
                <td
                  *ngIf="techIndex === 0"
                  class="comments project-comments-cell"
                  [attr.rowspan]="totalTechs"
                  [class.cell-hover]="isProjectColumnHovered(rowIndex)"
                >
                  <div class="comments-buttons">
                    <button
                      class="btn-view"
                      [class.btn-view-empty]="getCommentCount(row) === 0"
                      (click)="viewComments(row.project)"
                    >
                      View
                      <span
                        *ngIf="getCommentCount(row) > 0"
                        class="comment-count-badge"
                        >{{ getCommentCount(row) }}</span
                      >
                    </button>
                    <button
                      class="btn-add"
                      (click)="openCommentModal(row.project)"
                    >
                      Add
                    </button>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </tbody>
  </table>

  <!-- Modal para agregar comentarios -->
  <div
    class="comment-modal-overlay"
    *ngIf="isModalOpen"
    (click)="closeCommentModal()"
  >
    <div class="comment-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Add Comment for {{ selectedProject }}</h3>
        <button class="close-btn" (click)="closeCommentModal()">&times;</button>
      </div>
      <div class="modal-body">
        <div class="editor-toolbar">
          <button
            type="button"
            class="toolbar-btn"
            (click)="formatText('bold')"
            title="Bold"
          >
            <strong>B</strong>
          </button>
          <button
            type="button"
            class="toolbar-btn"
            (click)="formatText('italic')"
            title="Italic"
          >
            <em>I</em>
          </button>
          <button
            type="button"
            class="toolbar-btn"
            (click)="formatText('underline')"
            title="Underline"
          >
            <u>U</u>
          </button>
          <div class="toolbar-separator"></div>
          <button
            type="button"
            class="toolbar-btn"
            (click)="formatText('insertUnorderedList')"
            title="Bullet List"
          >
            ☰
          </button>
          <button
            type="button"
            class="toolbar-btn"
            (click)="formatText('insertOrderedList')"
            title="Numbered List"
          >
            ≡
          </button>
        </div>
        <div
          class="rich-text-editor"
          contenteditable="true"
          #richTextEditor
          (input)="onEditorInput($event)"
        ></div>
      </div>
      <div class="modal-footer">
        <button class="btn-cancel" (click)="closeCommentModal()">Cancel</button>
        <button class="btn-save" (click)="saveComment()">Save</button>
      </div>
    </div>
  </div>

  <!-- Upgrade confirmation modal -->
  <div
    class="comment-modal-overlay"
    *ngIf="isUpgradeConfirmOpen"
    (click)="cancelUpgrade()"
  >
    <div class="comment-modal upgrade-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Trigger Upgrade Workflow</h3>
        <button class="close-btn" (click)="cancelUpgrade()">&times;</button>
      </div>
      <div class="modal-body upgrade-modal-body" *ngIf="pendingUpgrade">
        <p>This will trigger an automated upgrade workflow for:</p>
        <ul class="upgrade-details">
          <li>
            <strong>Project:</strong>
            {{ pendingUpgrade.project_name | titleFormat }}
          </li>
          <li>
            <strong>Technology:</strong>
            {{ pendingUpgrade.technology | titleFormat }}
          </li>
          <li>
            <strong>Current version:</strong> v{{
              pendingUpgrade.current_version
            }}
          </li>
          <li>
            <strong>Target version:</strong> v{{
              pendingUpgrade.target_version
            }}
          </li>
        </ul>
        <p class="upgrade-warning">Are you sure you want to proceed?</p>
      </div>
      <div class="modal-footer">
        <button
          class="btn-cancel"
          (click)="cancelUpgrade()"
          [disabled]="isUpgrading"
        >
          Cancel
        </button>
        <button
          class="btn-save btn-upgrade"
          (click)="confirmUpgrade()"
          [disabled]="isUpgrading"
        >
          <span *ngIf="isUpgrading" class="upgrade-loading-label">
            <span class="upgrade-inline-spinner" aria-hidden="true"></span>
            Triggering...
          </span>
          <span *ngIf="!isUpgrading">Confirm Upgrade</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Upgrade result modal -->
  <div
    class="comment-modal-overlay"
    *ngIf="isUpgradeResultOpen"
    (click)="closeUpgradeResult()"
  >
    <div class="comment-modal upgrade-modal" (click)="$event.stopPropagation()">
      <!-- Success -->
      <ng-container *ngIf="upgradeResult">
        <div class="modal-header upgrade-result-header upgrade-result-success">
          <div class="upgrade-result-icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h3>Workflow Triggered</h3>
          <button class="close-btn" (click)="closeUpgradeResult()">
            &times;
          </button>
        </div>
        <div class="modal-body upgrade-modal-body">
          <p class="upgrade-result-message">{{ upgradeResult.message }}</p>
          <a
            class="upgrade-result-link"
            [href]="upgradeResult.link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
              />
              <polyline points="15 3 21 3 21 9" />
              <line x1="10" y1="14" x2="21" y2="3" />
            </svg>
            Monitor on GitHub Actions
          </a>
        </div>
      </ng-container>

      <!-- Error -->
      <ng-container *ngIf="upgradeError">
        <div class="modal-header upgrade-result-header upgrade-result-error">
          <div class="upgrade-result-icon">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <h3>Workflow Failed</h3>
          <button class="close-btn" (click)="closeUpgradeResult()">
            &times;
          </button>
        </div>
        <div class="modal-body upgrade-modal-body">
          <p class="upgrade-result-message">{{ upgradeError }}</p>
        </div>
      </ng-container>

      <div class="modal-footer">
        <button class="btn-save" (click)="closeUpgradeResult()">Close</button>
      </div>
    </div>
  </div>

  <!-- Toast notification -->
  <div
    class="upgrade-toast"
    *ngIf="toast"
    [class.toast-success]="toast.type === 'success'"
    [class.toast-error]="toast.type === 'error'"
  >
    <svg
      *ngIf="toast.type === 'success'"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
    <svg
      *ngIf="toast.type === 'error'"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
    {{ toast.message }}
  </div>
</div>
